//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

export const PROMOTED_POSTS_ACTIONS = {
    // Setup
  SETUP_PROMOTED_POSTS: 'SETUP_PROMOTED_POSTS',
  CLEAR_PROMOTED_POSTS_STATE: 'CLEAR_PROMOTED_POSTS_STATE',

    // Wizard Navigation
  UPDATE_ACTIVE_STEP: 'UPDATE_ACTIVE_STEP',
  UPDATE_WIZARD_STATES: 'UPDATE_WIZARD_STATES',

    // Get account data Actions
  REQUEST_AD_ACCOUNTS: 'REQUEST_AD_ACCOUNTS',
  RECEIVE_AD_ACCOUNTS: 'RECEIVE_AD_ACCOUNTS',
  UPDATE_SELECTED_ACCOUNT: 'UPDATE_SELECTED_ACCOUNT',

    // Manage Promotion Actions
  CREATE_PROMOTION: 'CREATE_PROMOTION',
  UPDATE_PROMOTION_STATUS: 'UPDATE_PROMOTION_STATUS',
};

export enum PromotedPostsStatuses {
    EDITING = 'editing',
    CREATED = 'created',
    PAUSED = 'paused',
    DELETED = 'deleted',
    ERROR = 'error',
}

export enum WIZARD_STATE_STATUSES {
    UNSTARTED = 'unstarted',
    ACTIVE = 'active',
    COMPLETE = 'complete',
}

export enum WIZARD_STEPS {
    ACCOUNT = 'account',
    TARGET = 'target',
    AUDIENCE = 'audience',
    BUDGET = 'budget',
    SUMMARY = 'summary',
}

export const ORDERED_WIZARD_STEPS: WIZARD_STEPS[] = [
  WIZARD_STEPS.ACCOUNT,
  WIZARD_STEPS.TARGET,
  WIZARD_STEPS.AUDIENCE,
  WIZARD_STEPS.BUDGET,
  WIZARD_STEPS.SUMMARY,
];

export const INITIAL_WIZARD_STATES = {
  [WIZARD_STEPS.ACCOUNT]: {
    value: WIZARD_STEPS.ACCOUNT,
    label: 'Account',
    status: WIZARD_STATE_STATUSES.ACTIVE,
  },
  [WIZARD_STEPS.TARGET]: {
    value: WIZARD_STEPS.TARGET,
    label: 'Link',
    status: WIZARD_STATE_STATUSES.UNSTARTED,
  },
  [WIZARD_STEPS.AUDIENCE]: {
    value: WIZARD_STEPS.AUDIENCE,
    label: 'Audience',
    status: WIZARD_STATE_STATUSES.UNSTARTED,
  },
  [WIZARD_STEPS.BUDGET]: {
    value: WIZARD_STEPS.BUDGET,
    label: 'Budget',
    status: WIZARD_STATE_STATUSES.UNSTARTED,
  },
  [WIZARD_STEPS.SUMMARY]: {
    value: WIZARD_STEPS.SUMMARY,
    label: 'Summary',
    status: WIZARD_STATE_STATUSES.UNSTARTED,
  },
};

export const PROMOTED_POSTS_ROUTES =  {
  PROMOTE_POST: 'instagramAccount.promotePost',
} as const;
